<template>
	<Modal @close="$emit('close')">
		<template slot="title">Shopify Customer</template>

		<template slot="body">
			<div style="width:820px; height:400px;">
				<div class="list_top_box">
					<span class="int_type_no_border mgr_10">
						<label>
							<input type="radio" v-model="mode" value="MAP" />
							<em class="lt_text">MAP</em>
						</label>
						<label>
							<input type="radio" v-model="mode" value="CREATE" />
							<em class="lt_text">CREATE</em>
						</label>
					</span>
					<span v-show="mode === 'MAP'">
						<span class="int_type_no_border mgr_5">
							<PartnerSelect v-model.trim="selected_customer_code" ph="Customer" :showName="true" @set-partner="setCustomer" />
						</span>
						<a href="javascript:void(0);" class="gray_bt" @click="mapCustomer()">Mapping Customer</a>
					</span>
				</div>
				<div v-show="mode === 'CREATE'">
					<table class="view_tbl" border="0">
						<colgroup>
							<col style="width:100px;" />
							<col style="width:300px;" />
							<col style="width:100px;" />
							<col style="width:300px;" />
						</colgroup>
						<tbody>
							<tr>
								<th>Code</th>
								<td colspan="3">
									<input type="text" v-model.trim="new_customer.code" class="tbl_int ssm2_int mgr_5" />
									<a href="javascript:void(0);" class="gray_bt" @click="setCustomerNewCode()">Auto Code</a>
								</td>
							</tr>
							<tr>
								<th>Name / Company</th>
								<td><input type="text" v-model.trim="new_customer.name" class="tbl_int" /></td>
								<th>Owner Name</th>
								<td><input type="text" v-model.trim="new_customer.owner_name" class="tbl_int" /></td>
							</tr>
							<tr>
								<th>Email</th>
								<td><input type="text" v-model.trim="new_customer.email" class="tbl_int" /></td>
								<th>Telephone</th>
								<td><input type="text" v-model.trim="new_customer.telephone" class="tbl_int" /></td>
							</tr>
							<tr>
								<th style="padding-top:10px;" rowspan="2">Address</th>
								<td style="padding-top:10px;" colspan="3">
									<input class="tbl_int" style="width:400px;" type="text" v-model.trim="new_customer.address_detail" />
									<br />
									<input class="tbl_int" style="width:400px;" type="text" v-model.trim="new_customer.address_detail2" placeholder="Address Line 2 (Optional)" />
								</td>
							</tr>
							<tr>
								<td colspan="3">
									<input type="text" class="tbl_int mm_int mgr_5" placeholder="CITY" v-model.trim="new_customer.address_city" />
									<input type="text" class="tbl_int sm_int mgr_5" placeholder="STATE" v-model.trim="new_customer.address_state" />
									<input type="text" class="tbl_int ssm_int mgr_5" placeholder="ZIP CODE" v-model.trim="new_customer.address_zipcode" />
									<span class="int_type_no_border mgr_10">
										<CodeSelect :width="100" :showDesc="false" :codes="countries" v-model.trim="new_customer.country" />
									</span>
								</td>
							</tr>
							<tr>
								<th>Sales Group</th>
								<td>
									<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="new_customer.sales_group_code"/></span>
								</td>
								<th>Payment Term</th>
								<td>
									<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="paymentTerms" v-model="new_customer.payment_term_code"/></span>
								</td>
							</tr>
							<tr>
								<th>Delivery Type</th>
								<td>
									<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="deliveryTypes" v-model="new_customer.delivery_type_code"/></span>
								</td>
								<th>Ship Charge</th>
								<td>
									<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="shipCharges" v-model="new_customer.ship_charge_code"/></span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="popup_bottom">
				<a href="javascript:void(0);" v-if="mode === 'CREATE'" class="search_bt mgr_5" @click="insertCustomer()">Create Customer</a>
				<a href="javascript:void(0);" class="gray_bt" @click="$emit('close')">Close</a>
			</div>
		</template>
	</Modal>
</template>

<script>
import PartnerSelect from '@/components/common/PartnerSelect';
import CodeSelect from '@/components/common/CodeSelect';
import Modal from '@/components/common/Modal';
import { apiCreateNewCustomer, apiInsertThirdPartyOrderCustomer } from '@/api/shopify/shopify_order.js';
import { apiSelectNewPartnerCode, apiDetailIndex, apiCheckPartnerExists } from '@/api/partner/index.js';
import { convertShopifyCustomer } from '@/views/shopify/shopify.js';
import _ from 'lodash';
export default {
	data: () => ({
		selected_customer_code: null,
		selected_customer: null,
		mode: 'MAP',
		new_customer: {
			code: null,
			partner_type: 'C',
			active_yn: 'Y',
			country: null,
			address_zipcode: null,
			address_state: null,
			address_city: null,
			address_detail: null,
			address_detail2: null,
			name: null,
			owner_name: null,
			telephone: null,
			email: null,
			sales_group_code: null,
			payment_term_code: null,
			ship_charge_code: null,
			delivery_type_code: null,
		},

		countries: [],
		deliveryTypes: [],
		shipCharges: [],
		salesGroups: [],
		paymentTerms: [],
	}),
	props: {
		shopify_customer: {
			type: Object,
			default: () => ({}),
		},
		store_no: {
			type: Number,
			default: null,
		},
	},
	components: {
		PartnerSelect,
		CodeSelect,
		Modal,
	},
	methods: {
		setCustomer(customer) {
			if (customer.code) this.$toast.success('SELECT CUSTOMER.');
			this.selected_customer = customer;
		},
		async mapCustomer() {
			if (!this.selected_customer_code) {
				this.$toast.error('Please. Select Customer First.');
				return;
			}

			const { data } = await apiInsertThirdPartyOrderCustomer(this.selected_customer_code, this.shopify_customer.id, this.store_no);
			if (data.result === 'FAIL') {
				this.$toast.error(data.msg);
			} else {
				this.selected_customer.cust_no = data.data;
				this.$toast.success('Success to Map Customer Data.');
				this.$emit('emitCustomer', this.selected_customer);
			}
		},
		makePassword() {
			let code = this.new_customer.code;
			let zipcode = this.new_customer.address_zipcode;
			if (!_.isEmpty(code)) {
				let first = code.slice(0, 1);
				let other = _.isEmpty(zipcode) ? '00000' : zipcode;
				this.new_customer.password = first + other;
			}
		},
		async getNewCustomerCode() {
			const { data } = await apiSelectNewPartnerCode();
			return data.new_customer_code;
		},
		async setCustomerNewCode() {
			this.new_customer.code = await this.getNewCustomerCode();
		},
		async makeNewCustomer() {
			this.shopify_customer.new_code = await this.getNewCustomerCode();
			this.new_customer = convertShopifyCustomer(this.shopify_customer);
			this.new_customer.store_no = this.store_no;
		},
		async checkCustomerCodeExists(customer) {
			const { data } = await apiCheckPartnerExists(customer);
			return data.result;
		},
		async insertCustomer() {
			if (_.isEmpty(this.new_customer.code)) {
				this.$toast.error('Input Customer Code.');
				return;
			}
			if (await this.checkCustomerCodeExists(this.new_customer)) {
				this.$toast.error('Duplicate Customer Code.');
				return;
			}

			this.makePassword();
			this.new_customer.program_customer_id = this.shopify_customer.id;
			const { data } = await apiCreateNewCustomer(this.new_customer);
			if (data.result === 'FAIL') {
				this.$toast.error(data.msg);
			} else {
				this.new_customer.cust_no = data.data;
				this.$toast.success('Success to Create Customer Data.');
				this.$emit('emitCustomer', this.new_customer);
			}
		},
		async index() {
			const { data } = await apiDetailIndex();

			this.countries = data.countryList || [];
			this.deliveryTypes = data.deliveryTypeList || [];
			this.shipCharges = data.shipChargeList || [];
			this.salesGroups = data.salesGroupList || [];
			this.paymentTerms = data.paymentTermList || [];
		},
	},
	async created() {
		await this.index();
		this.makeNewCustomer();
	},
};
</script>

<style></style>
